module.exports = new __parcel__URL__("product-requirements.b229ef14.png").toString();